import React from 'react';
import BannerEUFunds from '../shared/banners/BannerEUFunds';
import BannerMobileApplication from '../shared/banners/BannerMobileApplication';

const RightBanners = () => {
    return (
        <>
            <BannerMobileApplication />
            <div className='mb-4'></div>
            <BannerEUFunds />
        </>
    );
}

export default RightBanners;
